import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronLeft, Calendar, Package } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopFlyersArchivePage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/shops/${slug}/flyers/archive`)
      .then(({ data }) => setData(data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [slug]);

  const flyers = (data?.flyers || []).filter(f => (f.product_count || 0) > 0);

  return (
    <div data-testid="flyers-archive-page" className="pb-safe bg-[#FDFBF7] min-h-screen">
      <div className="bg-white border-b border-[#E8E3D9] p-4">
        <Link
          data-testid="back-to-shop"
          to={`/negozio/${slug}`}
          className="inline-flex items-center gap-1 text-sm text-[#5C554F] hover:text-[#C25934] mb-3"
        >
          <ChevronLeft size={16} /> Torna al negozio
        </Link>
        <h1 className="text-xl font-bold text-[#2A2624]" style={{ fontFamily: 'Outfit' }}>
          📚 Archivio Volantini
        </h1>
        {data?.shop && (
          <p className="text-xs text-[#877E78] mt-1">{data.shop.name}</p>
        )}
      </div>

      <div className="px-4 pt-4">
        {loading ? (
          <div className="space-y-3">
            {[1,2,3].map(i => <div key={i} className="h-28 skeleton-shimmer rounded-xl" />)}
          </div>
        ) : flyers.length === 0 ? (
          <div className="text-center py-16">
            <Calendar size={40} className="mx-auto text-[#877E78] mb-3" />
            <p className="text-[#877E78] text-sm">Nessun volantino precedente</p>
          </div>
        ) : (
          <div className="space-y-3">
            {flyers.map(f => (
              <Link
                key={f.id}
                to={`/volantino/${f.id}`}
                data-testid={`archive-flyer-${f.id}`}
                className="flex items-center gap-3 bg-white rounded-xl border border-[#E8E3D9] p-3 hover:border-[#C25934] transition-colors"
              >
                <div className="w-16 h-16 rounded-lg bg-[#F0EBE1] flex items-center justify-center text-3xl flex-shrink-0">
                  📰
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-[#2A2624]" style={{ fontFamily: 'Outfit' }}>
                    {f.title || `Volantino del ${f.date}`}
                  </p>
                  <p className="text-xs text-[#877E78] flex items-center gap-1 mt-0.5">
                    <Calendar size={11} /> {f.date}
                  </p>
                  <p className="text-xs text-[#4A6B53] flex items-center gap-1 mt-0.5">
                    <Package size={11} /> {f.product_count} prodotti
                  </p>
                </div>
                <span className="text-[#C25934] font-bold">→</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
